var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faExclamationCircle } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BFormCheckbox } from "bootstrap-vue";
import { computed, ref, watch } from "vue";
import { getNotificationsPreferencesFromServer, updateNotificationsPreferencesOnServer, } from "@/api/notifications.preferences";
import { useConfig } from "@/composables/config";
import { Toast } from "@/composables/toast";
import { browserSupportsPushNotifications, pushNotificationsEnabled, togglePushNotifications, } from "@/composables/utils/pushNotifications";
import AsyncButton from "@/components/Common/AsyncButton.vue";
import Heading from "@/components/Common/Heading.vue";
import LoadingSpan from "@/components/LoadingSpan.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'NotificationsPreferences',
    props: {
        embedded: { type: Boolean, default: true },
        headerSize: { default: "h-lg" }
    },
    setup(__props) {
        const props = __props;
        library.add(faExclamationCircle);
        const { config } = useConfig(true);
        const loading = ref(false);
        const errorMessage = ref(null);
        const pushNotificationsGranted = ref(pushNotificationsEnabled());
        const notificationsPreferences = ref({});
        const categories = computed(() => Object.keys(notificationsPreferences.value));
        const showPreferences = computed(() => {
            return !loading.value && config.value.enable_notification_system && notificationsPreferences.value;
        });
        const categoryDescriptionMap = {
            message: "You will receive notifications when someone sends you a message.",
            new_shared_item: "You will receive notifications when someone shares an item with you.",
        };
        function getNotificationsPreferences() {
            return __awaiter(this, void 0, void 0, function* () {
                loading.value = true;
                yield getNotificationsPreferencesFromServer()
                    .then((data) => {
                    notificationsPreferences.value = data.preferences;
                })
                    .catch((error) => {
                    errorMessage.value = error;
                })
                    .finally(() => {
                    loading.value = false;
                });
            });
        }
        function updateNotificationsPreferences() {
            return __awaiter(this, void 0, void 0, function* () {
                yield updateNotificationsPreferencesOnServer({ preferences: notificationsPreferences.value })
                    .then((data) => {
                    notificationsPreferences.value = data.preferences;
                    Toast.success("Notifications preferences updated");
                })
                    .catch((error) => {
                    errorMessage.value = error;
                });
            });
        }
        function capitalizeWords(str) {
            return str
                .split("_")
                .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" ");
        }
        function onTogglePushNotifications() {
            return __awaiter(this, void 0, void 0, function* () {
                pushNotificationsGranted.value = yield togglePushNotifications();
            });
        }
        watch(() => config.value.enable_notification_system, () => {
            if (config.value.enable_notification_system) {
                getNotificationsPreferences();
            }
        }, { immediate: true });
        return { __sfc: true, props, config, loading, errorMessage, pushNotificationsGranted, notificationsPreferences, categories, showPreferences, categoryDescriptionMap, getNotificationsPreferences, updateNotificationsPreferences, capitalizeWords, onTogglePushNotifications, FontAwesomeIcon, BAlert, BButton, BFormCheckbox, browserSupportsPushNotifications, AsyncButton, Heading, LoadingSpan };
    }
});
